export default "__VITE_ASSET__CBWsTFA0__"